import React, { useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminNavbar from "./AdminNavbar";

const AdminLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="flex">
      <AdminSidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
      <div className={`flex-1 min-h-screen transition-all duration-300 ${collapsed ? "ml-20" : "ml-64"}`}>
        <AdminNavbar />
        <main className="p-6 bg-neutral-950 text-white overflow-y-auto">{children}</main>
      </div>
    </div>
  );
};

export default AdminLayout;
